import jsCookie from "js-cookie";

export default class cookieHelp{
  constructor() {
  }

  static USER_KEY = 'user'

  static  getCookie (name="") {
    return jsCookie.get(name);
  }

  static  setCookie(name="",value=null,expires) {
    let date = new Date();
    // 设置时间一个小时
    date.setTime(date.getTime() + 3*60*60*1000);
    expires.expires ? jsCookie.set(name,value, expires) : jsCookie.set(name,value, {expires:date});
  }

  static  removeCookie(name="") {
    jsCookie.remove(name)
  }

}



// WEBPACK FOOTER //
// ./src/utils/jsCookies.js